<template>
	<n-input-otp
		ref="otpInputRef"
		v-model:value="model"
		:allow-input="(value: string) => isNumeric(value)"
		:disabled
		:loading
		:block="fluid"
		:length="OTP_LENGTH"
		:mask
		:placeholder
		:size="otpSize"
		:class="`otp-size-${size}`"
		@finish="finish()"
	/>
</template>

<script lang="ts" setup>
import type { InputOtpSize } from "naive-ui"
import { NInputOtp } from "naive-ui"
import { isNumeric } from "validator"
import { computed, onMounted, ref, toRefs } from "vue"

const props = defineProps<{
	mask?: boolean
	fluid?: boolean
	disabled?: boolean
	loading?: boolean
	autofocus?: boolean
	placeholder?: string
	size?: InputOtpSize | "extra-large"
}>()

const emit = defineEmits<{
	(e: "completed", value: string): void
	(e: "validation", value: boolean): void
}>()

const OTP_LENGTH = 6

const { disabled, loading, fluid, mask, placeholder, size } = toRefs(props)
const value = defineModel<string | null>("value", { default: null })

const otpInputRef = ref<InstanceType<typeof NInputOtp> | null>(null)

const model = computed({
	get: () => (value.value ? value.value.split("") : null),
	set: (newValue: string[] | undefined) => {
		value.value = (newValue || []).filter(o => !!o).join("")
		emit("validation", (newValue || []).filter(o => !!o).length === OTP_LENGTH)
	}
})

const otpSize = computed<InputOtpSize>(() => {
	if (size.value === "extra-large") {
		return "large"
	}

	return size.value || "large"
})

function finish() {
	emit("completed", value.value || "")
}

function focusOnChar() {
	otpInputRef.value?.focusOnChar(0)
}

onMounted(() => {
	if (props.autofocus) {
		focusOnChar()
	}
})

defineExpose({
	focusOnChar
})
</script>

<style lang="scss" scoped>
.n-input-otp {
	&.otp-size-extra-large {
		:deep(.n-input) {
			--n-height: 48px;
		}
	}
}
</style>
